module.exports = __webpack_public_path__ + "img/PEARLSAsset 210.04d24cf.svg";